import { render } from "./ZoneRateTable.vue?vue&type=template&id=270df217"
import script from "./ZoneRateTable.vue?vue&type=script&lang=ts"
export * from "./ZoneRateTable.vue?vue&type=script&lang=ts"

import "./ZoneRateTable.vue?vue&type=style&index=0&id=270df217&lang=scss"
script.render = render

export default script